let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6XoCv")).then(() => parcelRequire('lFPm8'));